// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oz5cX","left":"styles_left__36d5R"};